import {IsoDate} from "../../../pseudo-types/DateTypes";
import {Comparator} from "../../../types/GenericTypes";

export type TimeSeriesRecords = ReadonlyArray<TimeSeriesRecord>;

export class TimeSeriesRecord {

    private constructor(public readonly date: IsoDate,
                        public readonly open: number,
                        public readonly high: number,
                        public readonly low: number,
                        public readonly close: number,
                        public readonly volume: number,
                        public readonly value: number,
                        public readonly tradeCount: number,
                        public readonly marketVwap: number,
                        public readonly shortSellPosition: number,
                        public readonly shortSellPercent: number,
                        public readonly shortSold: number,
                        public readonly shortSoldPercent: number) {
    }

    public static of(date: IsoDate,
                     open: number,
                     high: number,
                     low: number,
                     close: number,
                     volume: number,
                     value: number,
                     tradeCount: number,
                     marketVwap: number,
                     shortSellPosition: number,
                     shortSellPercent: number,
                     shortSold: number,
                     shortSoldPercent: number): TimeSeriesRecord {
        return new TimeSeriesRecord(date,
                                    open,
                                    high,
                                    low,
                                    close,
                                    volume,
                                    value,
                                    tradeCount,
                                    marketVwap,
                                    shortSellPosition,
                                    shortSellPercent,
                                    shortSold,
                                    shortSoldPercent);
    }
}

export function sortTimeSeriesRows(): Comparator<TimeSeriesRecord> {
    return (a, b) => b.date.localeCompare(a.date);
}
